import { useTranslation } from 'react-i18next';
import { useModalContext } from '../../contexts/ModalContext';
import AppModal from './Modal';

const ModalPatientCreated = () => {
    const { t } = useTranslation();

    const { createdPatient, createdCode, setCreatedPatient } = useModalContext();

    const close = () => {
        setCreatedPatient(null);
    };

    if (!createdPatient) return <></>;

    return (
        <AppModal
            safeAction={close}
            safeText={t('button.close') as string}
        >
            <p>{t('feedback.patient_saved')}</p>
            <p className="bold">{createdCode}</p>
            <p className="bold">{createdPatient}</p>
            <p>{t('feedback.remember_code_patient')}</p>
            <p>{t('feedback.will_get_email_results')}</p>
        </AppModal>
    );
};

export default ModalPatientCreated;
